import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import DashboardContent from "./DashboardContent";
import Preloader from "@/components/Elements/Preloader";
import { fetchDashboardMatchesList } from "@/store/dashboardSlice";

const Dashboard = () => {
  const { loading } = useSelector(({ dashboard }) => dashboard);

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchDashboardMatchesList());
  }, []);

  return !loading ? <DashboardContent /> : <Preloader />;
};

export default Dashboard;
